import { createContext } from 'react';
import { User } from '../../models/UsersModels';

type UserDetailsContextData = User;

const UserDetailsContext = createContext({} as UserDetailsContextData | null);

export default UserDetailsContext;
